import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * RTO movements icon with optional primary gradient fill.
 */
@Component({
  selector: 'ic-movements',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-movements.html',
})
export class IcMovementsComponent {
  /** Icon width in px. @default 14 */
  @Input() width: number | string = 14;

  /** Icon height in px. @default 14 */
  @Input() height: number | string = 14;

  /** Solid fill when no gradient is provided. */
  @Input() color = '';

  /** Icon opacity. @default 1 */
  @Input() opacity = 1;

  /** Gradient start color when both start and end are set. */
  @Input() startColor: string | null = null;

  /** Gradient end color when both start and end are set. */
  @Input() endColor: string | null = null;

  /** Fallback fill when no color or gradient is provided. */
  defaultColor = '#B8C0C6';

  /** Unique SVG gradient id to avoid collisions. */
  gradientId = `movementsGradient-${Math.random().toString(36).slice(2)}`;

  /** Whether both gradient colors are non-empty. */
  get hasGradient(): boolean {
    return !!this.startColor?.trim() && !!this.endColor?.trim();
  }
}
